// queue.tags — pill/badge murni utk daftar antrian (port kondisiTag/bayarTag/refundBadge v0.18).
import { esc } from '@domain/format';
import type { Refund } from '@core/types';
import type { GaransiStatus } from '@domain/garansi';

/** Pill kondisi hasil servis (Sudah Jadi / Tidak Bisa / Dibatalkan / —). */
export function kondisiTag(hasil: string | null | undefined, kondisi?: string | null): string {
  let h = hasil || '';
  if (!h && kondisi) {
    if (/batal|dibatalkan/i.test(kondisi)) h = 'batal';
    else if (/tidak bisa/i.test(kondisi)) h = 'tidakbisa';
  }
  if (h === 'jadi') return '<span class="pill" style="background:var(--okbg);color:var(--ok)">Sudah Jadi</span>';
  if (h === 'tidakbisa') return '<span class="pill" style="background:var(--warnbg);color:var(--warn)">Tidak Bisa</span>';
  if (h === 'batal') return '<span class="pill" style="background:var(--dangerbg);color:var(--danger)">Dibatalkan</span>';
  return '<span class="pill" style="background:#eef2f6;color:var(--muted)">—</span>';
}

/** Badge refund (verified ✔ / pending ⏳). */
export function refundBadge(refund: Refund | null | undefined): string {
  if (!refund) return '';
  const v = refund.status === 'verified' ? '✔' : '⏳';
  return `<span class="pill" style="background:var(--dangerbg);color:var(--danger)">💸 Refund ${v}</span>`;
}

/** Badge status pembayaran (Lunas ✔ / Lunas / Tempo / In Payment). */
export function bayarTag(t: { refund?: Refund | null; lunas?: boolean | null; verified?: boolean | null; caraBayar?: string | null }): string {
  if (t.refund) return refundBadge(t.refund);
  if (t.lunas) return `<span class="pill" style="background:var(--okbg);color:var(--ok)">${t.verified ? 'Lunas ✔' : 'Lunas'}</span>`;
  if ((t.caraBayar ?? '').includes('Tempo')) return '<span class="pill" style="background:var(--warnbg);color:var(--warn)">Tempo</span>';
  return '<span class="pill" style="background:#e7f1fb;color:#1FA9E0">In Payment</span>';
}

/** Warna teks status garansi. */
export function garansiColor(gs: GaransiStatus): string {
  return gs.aktif ? 'var(--ok)' : (gs.txt === 'Tidak ada' ? 'var(--muted)' : 'var(--danger)');
}

/**
 * Penanda "unit ini datang kembali" untuk daftar antrian.
 *
 * Dua kondisi, satu penanda supaya petugas tak perlu menghafal dua istilah:
 *  • `servisUlang` — klaim garansi dikerjakan di tiket yang sama (sesi ≥2).
 *  • `priorRef`    — garansi habis → tiket BARU berbayar; nomor tiket lamanya disebut & bisa
 *                    diklik, karena riwayat itu yang dibutuhkan teknisi sebelum membongkar.
 * Tanpa ini, unit yang kembali tampil persis seperti unit baru (penyebab dua tiket kembar
 * kemarin lolos tanpa dicurigai).
 */
export function ulangBadge(servisUlang: boolean, priorRef: string | null | undefined): string {
  if (!servisUlang && !priorRef) return '';
  const asal = priorRef
    ? ` · dari <a class="tno-link" data-no="${esc(priorRef)}" style="color:inherit;text-decoration:underline">${esc(priorRef)}</a>`
    : '';
  return `<div style="margin-top:3px"><span class="pill" style="background:var(--dangerbg);color:var(--danger);white-space:nowrap">🔄 Servis Ulang${asal}</span></div>`;
}
